import ApparelPreorderNavPage from "@faire/prototype-playground/workspace/ats/apparel-preorder-nav";
import PdpMessageButtonInTopNavPage from "@faire/prototype-playground/workspace/ats/pdp-message-button-top-nav";
import { Route, Switch } from "react-router-dom";

export function AlexTsarapkineRoutes() {
  return (
    <Switch>
      <Route
        path="/ats/apparel-preorder-nav"
        component={ApparelPreorderNavPage}
      />
      <Route
        path="/ats/pdp-message-button-top-nav"
        component={PdpMessageButtonInTopNavPage}
      />
    </Switch>
  );
}

export const slug = "ats";
